import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactQuill, { Quill } from 'react-quill';
import quillEmoji from 'quill-emoji';
import 'react-quill/dist/quill.snow.css';
import { actions } from 'react-redux-form';
import 'quill-emoji/dist/quill-emoji.css';

import { lang } from '../utils/withLang';
import { getLengthOfSms } from '../modules/messages-types/functions';

// HTML => טקסט נקי, שומר רווחים ושורות כמו שהוזנו
function htmlToPlainText(html) {
  return html
    .replace(/<p><br\s*\/?><\/p>/gi, '\n')     // שורות ריקות
    .replace(/<br\s*\/?>/gi, '\n')             // <br> רגיל
    .replace(/<\/(p|div)>/gi, '\n')            // סוף בלוקים
    .replace(/<(p|div)[^>]*>/gi, '')           // התחלת בלוקים
    .replace(/&nbsp;|\u00a0/g, ' ')            // רווחים מיוחדים
    .replace(/<[^>]+>/g, '')                   // תגיות HTML אחרות
    .replace(/\r/g, '');                       // carriage return בלבד
}

// טקסט עם \n -> HTML להצגה ב־Quill
function plainTextToHtml(text) {
  return text ? text.replace(/\n/g, '<br>') : '';
}

class ReactQuillWrapper extends Component {
  constructor(props) {
    super(props);

    //**MAX LENGTH Verification(using state.isMaxLength, state.text, checkCharacterCount, part of onChangeHandler) -
	// made without any logic - there is a bug in React-Quill. Solution from GitHub**/
	//UPDATE: Customer canceled this verification

    this.state = {
      isMaxLength: false,
      text: plainTextToHtml(props.value),
    };

    this.modules = {
      toolbar: {
        container: '#toolbar' + ReactQuillWrapper.toolbarNum,
        handlers: {
          putUserName: this.putUserName,
          insertCustomTags: this.insertCustomTags.bind(this),
          emoji: function () {},
        },
      },
      clipboard: {
        matchVisual: false,
      },
      'emoji-toolbar': true,
      'emoji-textarea': true,
      'emoji-shortname': true,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  static toolbarNum = 1;

  insertCustomTags(args) {
    if (this.quill) {
      var cursorPosition = this.quill.getSelection().index;
      this.quill.insertText(cursorPosition, args);
      this.quill.setSelection(cursorPosition + args.length);
    }
  }

  onChangeHandler(content, delta, source, editor) {
    var html = editor && editor.root && editor.root.innerHTML ? editor.root.innerHTML : content;
    var plainText = htmlToPlainText(html);

    // לוג לבדיקה אם תרצי:
    // console.log('[נשלח ללקוח]', JSON.stringify(plainText));

    this.setState({ text: content });
    this.props.dispatch(actions.change(this.props.name, plainText));
  }

  generateStylesDynamically() {
    var output = '';
    var templateTags = this.props.templateTags;
    for (var key in templateTags) {
      if (templateTags.hasOwnProperty(key)) {
        output +=
          '.ql-picker.ql-insertCustomTags [data-value="' +
          templateTags[key] +
          '"]::before { content: "' +
          key +
          '"; }';
      }
    }
    return output;
  }

  showSmsLength(activeTab, menContent, womenContent, textFromManualSend, textFromManualRestaurantSend) {
    if (activeTab === 'content_for_men') {
      return getLengthOfSms(menContent);
    } else if (activeTab === 'content_for_women') {
      return getLengthOfSms(womenContent);
    } else {
      return getLengthOfSms(textFromManualSend);
    }
  }

  render() {
    var props = this.props;

    var length = this.showSmsLength(
      props.activeTab,
      props.menContent,
      props.womenContent,
      props.textFromManualSend,
      props.textFromManualRestaurantSend
    );

    var EmojiBlot = quillEmoji.EmojiBlot;
    var ShortNameEmoji = quillEmoji.ShortNameEmoji;
    var ToolbarEmoji = quillEmoji.ToolbarEmoji;
    var TextAreaEmoji = quillEmoji.TextAreaEmoji;

    Quill.register(
      {
        'formats/emoji': EmojiBlot,
        'modules/emoji-shortname': ShortNameEmoji,
        'modules/emoji-toolbar': ToolbarEmoji,
        'modules/emoji-textarea': TextAreaEmoji,
      },
      true
    );

    if (!props.formats) {
      return (
        <ReactQuill
          {...props}
          value={this.state.text}
          onChange={this.onChangeHandler}
        />
      );
    }

    return (
      <div>
        <style dangerouslySetInnerHTML={{ __html: this.generateStylesDynamically() }} />
        <CustomToolbar templateTags={props.templateTags} />
        <div>
          <ReactQuill
            {...props}
            value={this.state.text}
            modules={this.modules}
            formats={props.formats}
            theme="snow"
            onChange={this.onChangeHandler}
            ref={(el) => {
              this.quill = el ? el.getEditor() : null;
            }}
          />
        </div>
        <div className="row mt-2 justify-content-between px-3">
          <span>
            <span className="wysiwyg_number">{length}</span> {lang.sms_length}
          </span>
          <span>
            {lang.estimated_sms_quantity}{' '}
            <span className="wysiwyg_number">{Math.ceil(length / 160)}</span>
          </span>
        </div>
      </div>
    );
  }
}

function CustomToolbar(props) {
  return (
    <div id={'toolbar' + ReactQuillWrapper.toolbarNum++}>
      <select className="ql-header" defaultValue={'0'} onChange={function (e) { e.persist(); }}>
        <option value="1" />
        <option value="2" />
        <option value="3" />
        <option value="0" />
      </select>
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-clean" />
      <button className="ql-link" />
      <select className="ql-insertCustomTags">
        <option className="custom-dropdown-def-option" value=" " />
        {Object.keys(props.templateTags).map(function (key, i) {
          return (
            <option key={i} value={props.templateTags[key]}>
              {key}
            </option>
          );
        })}
      </select>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    activeTab: state.forms.messagesType.active_tab,
    menContent: state.forms.messagesType.text_men,
    womenContent: state.forms.messagesType.text_women,
    textFromManualSend: state.forms.manuallyMessage.text,
    textFromManualRestaurantSend: state.forms.manuallyMessageRestaurant.text,
  };
}

export default connect(mapStateToProps)(ReactQuillWrapper);
